import { WebcastListItemProps } from '../../components/WebcastListItem'
import fromUnixTime from 'date-fns/fromUnixTime'
import fetchJSON from '../fetchJSON'
// import { xssSanitize as sanitize } from '@bt-react/libs/sanitize'

// Only executes on the server-side

export type ChannelFeedResponse = WebcastListItemProps[] | []

export const defaultState = [
  
]

/**
 * Takes the response from the XML entry item and formats it to WebcastListItemProps
 * @param entry 
 */
export function convertResultToWebcastListItem (entry): WebcastListItemProps {

  const { communication, channel, links = [], start, summary, title, status, duration } = entry
  const thumbnail = links.find(link => (link?.title ?? '') === 'preview') ?? {}
  const url = links.find(link => (link?.rel ?? '') === 'alternate') ?? {}
  const date = fromUnixTime(start).toISOString()

  return {
    date,
    id: communication?.id,
    channelId: channel?.id,
    thumbnail: {
      alt: title,
      url: thumbnail?.href ?? ''
    },
    title: title,
    description: summary,
    // title: sanitize(title),
    // description: sanitize(summary),
    link: url?.href ?? '',
    status,
    duration
  }

}

export function formatChannelFeedResponse (response, webcastId?: string): WebcastListItemProps[] {

  let items: WebcastListItemProps[] = []

  if (typeof response?.entries === 'undefined') return []

  items = response.entries.map(convertResultToWebcastListItem).filter((talk: WebcastListItemProps) => talk.id.toString() !== webcastId)

  return items

}

async function fetchChannelFeed (channelId = '', webcastId = '', hostUrl = ''): Promise<ChannelFeedResponse> {

  if (!channelId) return formatChannelFeedResponse({})

  const { data } = await fetchJSON<WebcastListItemProps>('fetchChannelFeed', `${hostUrl || process.env.HOST}/service/channel/v2/channel/${channelId}/feed?size=18&webcastStatus=upcoming,recorded,live`)

  return formatChannelFeedResponse(data, webcastId)

}

export default fetchChannelFeed
